import React, { Component } from 'react';
import { Container } from "reactstrap";

//Import Containers
import SectionTitle from "../../components/Shared/section-title";
import ReviewsSlider from "../../components/Shared/reviews-slider";

//Import Images
import img1 from "../../images/client/01.jpg";
import img2 from "../../images/client/02.jpg";
import img3 from "../../images/client/03.jpg";
// import img4 from "../../images/client/04.jpg";
// import img5 from "../../images/client/05.jpg";
// import img6 from "../../images/client/06.jpg";

class Testimonials extends Component {
    state = {
        reviews : [
            { id : 1, img : img1, name : "Thomas Israel", post : "C.E.O", desc : "5 Star service. Seller truly cares for your success. He helped installed the automation from start to finish. We did testing and making sure it works. If you don't have a telegram channel to follow with reliable signals, seller will help you also. Highly recommend.", rating : 5, profle: "https://www.fiverr.com/codeblue702", source: "https://www.fiverr.com/share/X0zpRm" },
            { id : 2, img : img2, name : "Barbara McIntosh", post : "M.D", desc : "The service was amazing! Very professional and willing to accommodate all my customization requests. Great communication as well. The code works seamlessly. They were able to meet my deadline and worked extra late/long hours to make sure I was taken care of. Patiently helped with each one of my requests. I honestly could not be more pleased. So grateful I found them. Definitely would recommend this service!!!.", rating : 5, profle: "https://www.fiverr.com/josephhicken", source: "https://www.fiverr.com/share/vb1NzN"  },
            { id : 3, img : img3, name : "Carl Oliver", post : "P.A", desc : "The app works really well, and the customer support is remarkable. Probably the best choice if you want a custom telegram copier.", rating : 5, profle: "https://www.fiverr.com/leandronickisch", source: "https://www.fiverr.com/share/X0zpRm"  },
        ],
    }
    render() {
        return (
            <React.Fragment>
                <Container>
                    {/* section title */}
                    <SectionTitle title="Likes and Dislikes, Traders in their own words" desc="we are so excited and happy that our customers are succesfull and happy to share their story with us." />

                    {/* clients slider */}
                    <ReviewsSlider reviews={this.state.reviews}/>
                </Container>
            </React.Fragment>
        );
    }
}

export default Testimonials;